export const environment = {
  production: false,
  environmentName: 'dev',
  mainServiceUrl: 'https://dev.api.gvgolfclub.com/',
  pgaEmail: 'membership@pgaofcanada.com',
  pgaSiteUrl: 'pgaofcanada.com',
  internalSiteUrl: 'https://dev.internal.gvgolfclub.com/',
  memberSiteUrl: 'https://dev.api.gvgolfclub.com/',
};
